<template>
  <div id="app">
    <template>
      <center>
        <v-dialog
          v-model="dialog"
          persistent
          max-width="1024px">
          <img
            class=""
            src="/img/close.png"
            loading="lazy"
            alt="Space Banner Image"
            width="1024px"
            height="780px"
          />
        </v-dialog>
      </center>
    </template>
    <component
      :is="layout"
      :active-basic-id="activeBasicId"
      :profile-picture="userProfile.pictureUrl"
      :display-name="userProfile.displayName"
      :has-active-line-official-account="hasActiveLineOfficialAccount"
      :has-orders-by-user-id="hasOrdersByUserId"
      :orders-by-user-length="ordersByUserId.length"
    >
      <router-view />
      <cookie-consent-footer v-if="!isAcceptAll" />
    </component>

    <app-loading :active="$wait.is('app loading')"></app-loading>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import { hasAcceptedCookie,
  getAcceptedCookie,
  PERFORMANCE_COOKIE,
  ADVERTISING_COOKIE,
  startGoogleAnalaytics,
  stopGoogleAnalaytics
} from '@/utils/cookieConsent'

export default {
  name: 'App',
  components: {
    AppLoading: () => import('@/components/AppLoading.vue'),
    CookieConsentFooter: () => import('@/components/CookieConsent/Footer.vue')
  },
  data() {
    return {
      dialog: false,
      defaultLayout: 'default-layout'
    }
  },
  computed: {
    ...mapState('Order', ['ordersByUserId']),
    ...mapState('User', ['userProfile']),
    ...mapGetters({
      activeBasicId: 'User/activeBasicId',
      isAcceptAll: 'CookieConsent/isAcceptAll'
    }),
    layout() {
      if (this.$route.name == null) {
        return 'no-sidebar-layout'
      }

      return this.$route.meta.layout || this.defaultLayout
    },
    hasActiveLineOfficialAccount() {
      return !!this.userProfile.activeLineOfficialAccount
    },
    hasOrdersByUserId() {
      return this.ordersByUserId.length > 0
    }
  },
  created() {
    if (this.$utils.createDayjsDate().isBetween('2020-08-31', '2020-09-07', null, '[]')) {
      this.$swal({
        title: 'ประกาศ',
        type: 'warning',
        html: `
          แจ้งระบบหยุดทำการ
          <span style="font-weight: bold; color: #01BB00;">ในวันที่ 4-7 กันยายน 2563</span>
          <div style="margin-top: 16px;">เนื่องจากเป็นวันหยุดนักขัตฤกษ์ประจำปี ทั้งนี้ลูกค้าสามารถทำรายการและแนบหลักฐานการชำระที่เว็บไซต์ไว้ในระบบได้ก่อน</div>
          <div>โดยเจ้าหน้าที่จะเร่งดำเนินการให้ ในวันเปิดทำการ
            <div style="margin: 16px 0; font-weight: bold; color: #01BB00;">วันอังคารที่ 8 กันยายน 2563</div>
            ขออภัยในความไม่สะดวก</div>
          <div>หากต้องการติดต่อเจ้าหน้าที่ สามารถติดต่อได้ที่ <span style="font-weight: bold; color: #01BB00;">@linebysellsuki</span></div>
        `,
        confirmButtonColor: '#01BB00',
        confirmButtonText: 'ตกลง'
      })
    }
  },
  async mounted() {
    if (hasAcceptedCookie(this.$cookies)) {
      const accepted = getAcceptedCookie(this.$cookies)?.purposes

      await this.setAcceptPerformance(accepted[PERFORMANCE_COOKIE])
      await this.setAcceptAdvertising(accepted[ADVERTISING_COOKIE])

      if (accepted[PERFORMANCE_COOKIE]) {
        startGoogleAnalaytics(this.$gtag)
      } else {
        stopGoogleAnalaytics(this.$gtag)
      }
    }
  },
  methods: {
    ...mapActions({
      setAcceptPerformance: 'CookieConsent/setAcceptPerformance',
      setAcceptAdvertising: 'CookieConsent/setAcceptAdvertising'
    }),
    ...mapWaitingActions('CookieConsent', {
      setAcceptPerformance: 'app loading',
      setAcceptAdvertising: 'app loading'
    })
  }
}
</script>

<style lang="scss">
@import "~sweetalert2/dist/sweetalert2.min.css";
@import "@/assets/scss/main.scss";
@import "@/assets/scss/override.scss";
@import "@/assets/scss/print.scss";

.swal2-title {
  font-size: 1.8em;
}

.swal2-confirm.swal2-styled {
  height: 36px;
  min-width: 64px;
  padding: 0 16px;
  border-radius: 28px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  min-width: 150px;

  &:hover {
    background-image: initial;
  }
}
.swal2-cancel.swal2-styled {
  height: 36px !important;
  min-width: 64px;
  padding: 0 16px;
  border-radius: 28px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  min-width: 150px;

  &:hover {
    background-image: initial;
  }
}
</style>
